<template>
    <div class="w-full overflow-hidden bg-white mt-4 mb-24 font-poppins">
        <ToastAlert
        :is-active="toastAlert"
        :type="typeMsg"
        :message="msg"
        :title="tittle"
        />
        <!-- LOADER -->
        <div v-if="loader_profile" class="fixed inset-0 flex items-center justify-center bg-white  z-50">
          <img
            src="@/assets/imgs/tuin_loader_v2.gif"
            alt="cargando..."
            class=" w-[500px]"
          >
        </div>
        <div v-if="!loader_profile" class="relative">
          <div class="flex justify-center px-4">
            <div class="w-full max-w-[384px] flex flex-col gap-5">
              <!-- Título -->
              <div class="flex">
                <div class="text-black text-xl font-medium font-['Poppins'] leading-normal">
                  Añadir nueva tarjeta
                </div>
              </div>
              <form @submit.prevent="handleSubmit" class="space-y-5">
                <!-- Formulario -->
                <div class="flex flex-col gap-2.5">
                  <!-- Nombre Completo -->
                  <div class="flex flex-col gap-1.5">
                    <label class="text-neutral-500 text-sm font-medium">
                      Nombre Completo*
                    </label>
                    <input
                      v-model="formData.fullName"
                      type="text"
                      placeholder="Ingresa tu nombre completo"
                      class="w-full px-4 py-2 bg-white rounded-md border border-zinc-200 text-base font-light text-neutral-500 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:border-transparent transition-all"
                      required
                    >
                  </div>

                  <!-- Número de tarjeta -->
                  <div class="flex flex-col gap-1.5">
                    <label class="text-neutral-500 text-sm font-medium">
                      Número de tarjeta*
                    </label>
                    <input
                      v-model="formData.cardNumber"
                      type="text"
                      placeholder="Ingresa el número de tu tarjeta"
                      maxlength="19"
                      @input="formatCardNumber"
                      class="w-full px-4 py-2 bg-white rounded-md border border-zinc-200 text-base font-light text-neutral-500 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:border-transparent transition-all"
                      required
                    >
                  </div>

                  <!-- CVC -->
                  <div class="flex flex-col gap-1.5">
                    <label class="text-neutral-500 text-sm font-medium">
                      CVC*
                    </label>
                    <input
                      v-model="formData.cvc"
                      type="text"
                      placeholder="Ingresa el código de seguridad"
                      maxlength="4"
                      @input="formatCVC"
                      class="w-full px-4 py-2 bg-white rounded-md border border-zinc-200 text-base font-light text-neutral-500 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:border-transparent transition-all"
                      required
                    >
                  </div>

                  <!-- Fecha de expiración -->
                  <div class="flex flex-col gap-1.5">
                    <label class="text-neutral-500 text-sm font-medium">
                      Fecha de expiración*
                    </label>
                    <div class="relative">
                      <div class="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none">
                        <svg
                          class="w-4 h-4"
                          viewBox="0 0 16 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path 
                            fill-rule="evenodd" 
                            clip-rule="evenodd" 
                            d="M0 2.5C0 1.96957 0.210714 1.46086 0.585786 1.08579C0.960859 0.710714 1.46957 0.5 2 0.5L14 0.5C14.5304 0.5 15.0391 0.710714 15.4142 1.08579C15.7893 1.46086 16 1.96957 16 2.5V14.5C16 15.0304 15.7893 15.5391 15.4142 15.9142C15.0391 16.2893 14.5304 16.5 14 16.5H2C1.46957 16.5 0.960859 16.2893 0.585786 15.9142C0.210714 15.5391 0 15.0304 0 14.5V2.5ZM15 4.5H11V7.5H15V4.5ZM15 8.5H11V11.5H15V8.5ZM15 12.5H11V15.5H14C14.2652 15.5 14.5196 15.3946 14.7071 15.2071C14.8946 15.0196 15 14.7652 15 14.5V12.5ZM10 15.5V12.5H6V15.5H10ZM5 15.5V12.5H1V14.5C1 14.7652 1.10536 15.0196 1.29289 15.2071C1.48043 15.3946 1.73478 15.5 2 15.5H5ZM1 11.5H5V8.5H1V11.5ZM1 7.5H5V4.5H1V7.5ZM6 4.5V7.5H10V4.5H6ZM10 8.5H6V11.5H10V8.5Z" 
                            fill="#737373"
                          />
                        </svg>
                      </div>
                      <input
                        v-model="formData.expirationDate"
                        type="text"
                        placeholder="MM/AA"
                        maxlength="5"
                        @input="formatExpirationDate"
                        class="w-full pl-10 pr-4 py-2 bg-white rounded-md border border-zinc-200 text-base font-light text-neutral-500 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:border-transparent transition-all"
                        required
                      >
                    </div>
                  </div>
                </div>
                <!-- Botón agregar tarjeta -->
                <fwb-button
                  @click="addCard"
                  :disabled="!isFormValid || loader_profile"
                  class="w-full px-5 py-2.5 bg-rose-500 text-white text-sm font-medium rounded-lg border border-rose-500 hover:bg-rose-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all focus:outline-none focus:ring-2 focus:ring-rose-500 focus:ring-offset-2"
                >
                  <span class="inline-flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="white" class="w-5 h-5">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.5 5.5C10.7652 5.5 11.0196 5.60536 11.2071 5.79289C11.3946 5.98043 11.5 6.23478 11.5 6.5V9.5H14.5C14.7652 9.5 15.0196 9.60536 15.2071 9.79289C15.3946 9.98043 15.5 10.2348 15.5 10.5C15.5 10.7652 15.3946 11.0196 15.2071 11.2071C15.0196 11.3946 14.7652 11.5 14.5 11.5H11.5V14.5C11.5 14.7652 11.3946 15.0196 11.2071 15.2071C11.0196 15.3946 10.7652 15.5 10.5 15.5C10.2348 15.5 9.98043 15.3946 9.79289 15.2071C9.60536 15.0196 9.5 14.7652 9.5 14.5V11.5H6.5C6.23478 11.5 5.98043 11.3946 5.79289 11.2071C5.60536 11.0196 5.5 10.7652 5.5 10.5C5.5 10.2348 5.60536 9.98043 5.79289 9.79289C5.98043 9.60536 6.23478 9.5 6.5 9.5H9.5V6.5C9.5 6.23478 9.60536 5.98043 9.79289 5.79289C9.98043 5.60536 10.2348 5.5 10.5 5.5Z"
                      />
                    </svg>

                    <span class="text-white text-sm font-medium font-['Inter'] leading-tight">
                      Agregar nueva tarjeta
                    </span>
                  </span>
                </fwb-button>
              </form>
            </div>
          </div>

          <!-- Modal (si existe) -->
          <div
            v-if="showModal"
            class="fade-in"
          >
            <ModalFormPaymentComponent
              :address="address"
              :export_lat="property_lt"
              :export_ln="property_ln"
              @update-location="handleLocationUpdate"
            />
            <!-- Botón de ubicacion -->
            <div class="flex flex-1 justify-start items-start mt-4 p-2 ml-2">
              <fwb-button
                color="default"
                :disabled="!isFormValid || loader_profile"
                @click="openModalMaps"
              >
                Regresar a datos de ubicación
              </fwb-button>
            </div>
          </div>
        </div>
    </div>
      
</template>

<script setup>
  import { ref, computed } from 'vue';
  import {
    FwbButton,
  } from "flowbite-vue";

  const loader_profile = ref(false);

  // Variables reactivas
  const formData = ref({
    fullName: '',
    cardNumber: '',
    cvc: '',
    expirationDate: ''
  });

  const isFormValid = computed(() => {
    return (
      formData.value.fullName.trim() !== '' &&
      formData.value.cardNumber.replace(/\s/g, '').length >= 13 &&
      formData.value.cvc.length >= 3 &&
      formData.value.expirationDate.length === 5
    );
  });

  function formatCardNumber(event) {
    let value = event.target.value.replace(/\s/g, '');
    value = value.replace(/\D/g, '');
    
    let formattedValue = '';
    for (let i = 0; i < value.length; i++) {
      if (i > 0 && i % 4 === 0) {
        formattedValue += ' ';
      }
      formattedValue += value[i];
    }
    
    formData.value.cardNumber = formattedValue;
  }

  function formatCVC(event) {
    let value = event.target.value.replace(/\D/g, '');
    formData.value.cvc = value;
  }

  function formatExpirationDate(event) {
    let value = event.target.value.replace(/\D/g, '');
    
    if (value.length >= 2) {
      value = value.substring(0, 2) + '/' + value.substring(2, 4);
    }
    
    formData.value.expirationDate = value;
  }
  
  function handleSubmit() {
    if (isFormValid.value) {
      loader_profile.value = true;
      
      // Simular procesamiento de pago
      setTimeout(() => {
        //loader_profile.value = false;
        
        // Resetear formulario
        formData.value = {
          fullName: '',
          cardNumber: '',
          cvc: '',
          expirationDate: ''
        };
        
        setTimeout(() => {
          //toastAlert.value = false;
        }, 3000);
      }, 2000);
    }
  }
  // Métodos
  const addCard = () => {
    // Lógica para agregar tarjeta
    console.log('Agregar tarjeta');
  };
</script>

<style scoped>
  .fade-in {
    animation: fadeIn 0.3s ease-in;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
</style>